import { Icon } from "../components/Icon";
import { Btn, Card, PageHead } from "../components/kit";

const CARDS = [
  { ic: "book-open", t: "Documentation", d: "Guides for every feature" },
  { ic: "message-circle-question", t: "What can Orbit do?", d: "Tour the capabilities" },
  { ic: "life-buoy", t: "Contact support", d: "We reply within a day" },
  { ic: "message-square-heart", t: "Send feedback", d: "Request a lesson or report a bug" },
  { ic: "graduation-cap", t: "Getting-started guide", d: "Set up Orbit in 5 minutes" },
  { ic: "keyboard", t: "Keyboard shortcuts", d: "Work faster with hotkeys" },
];

export function HelpPage() {
  return (
    <div className="page">
      <PageHead title="Help & support" sub="Learn what Orbit can do, read the docs, or reach us when you’re stuck." />

      <div className="help-grid">
        {CARDS.map((c, i) => (
          <button className="help-card" key={i}>
            <span className="help-ic"><Icon name={c.ic} size={20} /></span>
            <div className="help-t">{c.t}</div>
            <div className="help-d">{c.d}</div>
            <Icon name="arrow-up-right" size={16} className="help-arrow" color="var(--fg-3)" />
          </button>
        ))}
      </div>

      <Card title="Status" icon="activity">
        <div className="set-row" style={{ padding: 0 }}>
          <span className="set-ic" style={{ background: "var(--live-soft)", color: "var(--live-dim)" }}>
            <Icon name="check" size={17} strokeWidth={2.4} />
          </span>
          <div className="set-body">
            <div className="set-t">All systems operational</div>
            <div className="set-d">Orbit · API · Web app</div>
          </div>
          <Btn variant="ghost" size="sm" iconRight="arrow-up-right">Status page</Btn>
        </div>
      </Card>
    </div>
  );
}
